import React, { useState } from "react";
import { IMG_CDN_URL } from "../../utils/constants";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Play, Info, Plus } from "lucide-react";

interface MovieCardProps {
  movieId: number;
  posterPath: string | null;
}

const MovieCard: React.FC<MovieCardProps> = ({ movieId, posterPath }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (!posterPath) return null;

  return (
    <div
      className="relative flex-shrink-0 w-36 md:w-56 px-2 py-4 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={`/browse/showmovie/${movieId}`}>
        <motion.div
          whileHover={{
            scale: 1.15,
            zIndex: 50,
            transition: { duration: 0.3 }
          }}
          className="relative rounded-lg overflow-hidden shadow-2xl cursor-pointer bg-gray-900 border border-white/5"
        >
          <img
            className="w-full h-auto object-cover rounded-lg"
            src={IMG_CDN_URL + posterPath}
            alt="Movie Card"
            loading="lazy"
          />

          <AnimatePresence>
            {isHovered && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent flex flex-col justify-end p-4 space-y-3"
              >
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center hover:bg-gray-200 transition-colors">
                    <Play size={16} fill="black" className="ml-0.5 text-black" />
                  </div>
                  <div className="w-8 h-8 rounded-full bg-gray-600/50 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-gray-600/80 transition-colors">
                    <Plus size={16} className="text-white" />
                  </div>
                  <div className="flex-1"></div>
                  <div className="w-8 h-8 rounded-full bg-gray-600/50 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-gray-600/80 transition-colors">
                    <Info size={16} className="text-white" />
                  </div>
                </div>

                <div className="flex items-center space-x-2 text-[10px] md:text-xs">
                  <span className="text-green-500 font-bold">98% Match</span>
                  <span className="px-1 border border-gray-400 text-gray-400 leading-none py-0.5 rounded-sm">13+</span>
                  <span className="text-gray-300">2h 15m</span>
                </div>

                <div className="flex flex-wrap gap-1">
                  <span className="text-[10px] text-white">Action</span>
                  <span className="text-[10px] text-gray-400 opacity-50">•</span>
                  <span className="text-[10px] text-white">Sci-Fi</span>
                  <span className="text-[10px] text-gray-400 opacity-50">•</span>
                  <span className="text-[10px] text-white">Thriller</span>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </Link>
    </div>
  );
};

export default MovieCard;
